export const ForecastPeriodType = {
    hourly: 'hourly',
    weekly: 'weekly'
} as const;